import { graphql } from 'gatsby';
import React from 'react';
import ItemsList from '../components/ItemsList';
import Layout from '../components/Layout';
import { ItemsPageGrid } from '../styles/Grids';
import styled from 'styled-components';

/* MWW = max-width wrapper */
const MalaMenuMWW = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 32px;
`;

export default function BrowsePage(props) {
  const items = props.data.items.nodes;
  return (
    <div>
      <Layout>
        <MalaMenuMWW>Mala menu goes here</MalaMenuMWW>
        <ItemsPageGrid>
          <ItemsList items={items} />
        </ItemsPageGrid>
      </Layout>
    </div>
  );
}

export const query = graphql`
  query ItemQuery {
    items: allSanityItem(sort: { fields: price, order: ASC }) {
      nodes {
        description
        id
        image {
          asset {
            gatsbyImageData(
              aspectRatio: 1
              layout: CONSTRAINED
              placeholder: BLURRED
            )
            url
          }
        }

        name
        price
        slug {
          current
        }
      }
    }
  }
`;
